import { useContext, useEffect, useState } from "react";
import CancelButton from "../../assets/images/CancelButton.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import UpdatesUnreadLogo from "../../assets/images/UpdatesUnreadLogo.svg";
import UpdatesReadLogo from "../../assets/images/UpdatesReadLogo.svg";
import UnreadUpdateDarkArror from "../../assets/images/UnreadUpdateDarkArror.svg";
import {
  HelpHubUpdatesTypes,
  QuestCriteriaWithStatusType,
} from "./HelpHub.type";
import QuestContext from "../QuestWrapper";
import config from "../../config";
import { claimQuest } from "./Helphub.service";
import HelphubSvg from "./HelphubSvg";
import { getColorVariations } from "./components/helperfunction";
import { extractGradientColors, useGeneral } from "../../general";

const HelpHubUpdates = (props: HelpHubUpdatesTypes) => {
  const {
    updateData,
    questId,
    userId,
    token,
    contentConfig,
    styleConfig,
    claimStatusUpdates = [],
    setClaimStatusUpdates,
    onlineComponent,
    setShowBottomNavigation,
    entityImage,
    setHelpHub,
    uniqueUserId,
    uniqueEmailId,
    campaignVariationId,
    entityAuthenticationToken,
    isActive,
    BrandTheme,
    QuestThemeData,
    isOffline,
  } = props;
  const [filterData, setFilterData] = useState<QuestCriteriaWithStatusType[]>(
    []
  );
  const [searchData, setSearchData] = useState<string | number>("");
  const { apiKey, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;
  const general = useGeneral('quest')

  useEffect(() => {
    let data = updateData.filter((value: QuestCriteriaWithStatusType) => {
      return value?.linkTitle
        ?.toLowerCase()
        .includes(searchData?.toString().toLowerCase());
    });
    setFilterData(data);
  }, [updateData, searchData]);

  useEffect(() => {
    if (props?.isOffline) return;
    general.trackEvent(
      "quest-helphub-updates-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
  }, []);

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  const getTimeDifference = (date: string) => {
    const now = new Date().getTime();
    const past = new Date(date).getTime();
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return `Today`;
    if (minutes < 60) return `Today`;
    if (hours < 24) return `Today`;
    if (days === 1) return "Yesterday";
    if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
    return `${years || 1} year${years !== 1 ? "s" : ""} ago`;
  };

  const readUpdate = async (criteriaId: string, links?: string) => {
    if (onlineComponent) {
      let claimResponse = await claimQuest(
        BACKEND_URL,
        entityId,
        questId,
        userId,
        token,
        apiKey,
        criteriaId,
        campaignVariationId,
        [],
        uniqueUserId,
        uniqueEmailId,
        apiType,
        entityAuthenticationToken
      );
      if (claimResponse.success) {
        setClaimStatusUpdates &&
          setClaimStatusUpdates([...claimStatusUpdates, criteriaId]);
      }
    } else {
      setClaimStatusUpdates &&
        setClaimStatusUpdates([...claimStatusUpdates, criteriaId]);
    }
  };

  const [showOneUpdate, setshowOneUpdate] = useState(false);
  const [updateOneData, setUpdateOneData] =
    useState<QuestCriteriaWithStatusType>();
  const [updateOneoutAnimation, setUpdateOneOutAnimation] = useState<
    boolean | null
  >(null);
  const [updateOutAnimation, setUpdateOutAnimation] = useState<boolean | null>(
    null
  );

  const [updateOutTempAnimation, setUpdateOutTempAnimation] = useState<
    boolean | null
  >(null);

  const handleShowUpdate = (value: any) => {
    setUpdateOutAnimation(true);
    setUpdateOneData(value);

    setTimeout(() => {
      setshowOneUpdate((prev) => !prev);
      setShowBottomNavigation && setShowBottomNavigation((prev) => !prev);
      setUpdateOneOutAnimation(false);
    }, 100);
  };

  const wrapLinksInText = (text: string) => {
    // const urlRegex = /(\bhttps?:\/\/[^\s]+)/gi;
    const urlRegex = /(\bhttps?:\/\/[^\s)]+)/gi; // This stops at ')' in URLs

    const parts = text.split(urlRegex);

    const wrappedText = parts.map((part, index) => {
      if (urlRegex.test(part)) {
        const cleanUrl =
          part.endsWith(".") ||
            part.endsWith(")") ||
            part.endsWith("]") ||
            part.endsWith("}")
            ? part?.slice(0, -1)
            : part;
        return (
          <a key={index} href={cleanUrl} target="_blank">
            {cleanUrl}
          </a>
        );
      }
      return part;
    });

    return <>{wrappedText}</>;
  };

  let color = BrandTheme?.primaryColor || QuestThemeData?.accentColor;
  if (color?.includes("gradient")) {
    color = extractGradientColors(color);
  }

  return (
    <>
      {!showOneUpdate && (
        <div
          className={`helpHubUpdatesCont animatedDissolve ${updateOutAnimation
            ? "updateOutAnimation"
            : updateOutTempAnimation
              ? "updateInAnimation"
              : ""
            }`}
          style={{
            background: themeConfig?.backgroundColor,
            ...styleConfig?.Updates?.Form,
          }}
        >
          <div className="q-helphub-updates-upper-cont ">
            <div className="q-helphub-updates-upper-cont-text">
              <div>
                <div
                  className="q-helphub-updates-upper-cont-text-head"
                  style={{
                    color:
                      BrandTheme?.titleColor || themeConfig?.primaryColor,
                    ...styleConfig?.Updates?.Topbar?.Heading,
                  }}
                >
                  {contentConfig?.heading || "Updates"}
                </div>
                <div
                  className="q-helphub-updates-upper-cont-text-para"
                  style={{
                    color:
                      BrandTheme?.contentColor || themeConfig?.secondaryColor,
                    ...styleConfig?.Updates?.Topbar?.SubHeading,
                  }}
                >
                  {contentConfig?.subHeading ||
                    "Welcome back, Please talk to us to understand"}
                </div>
              </div>
              <div className="q-helphub-updates-upper-cont-text-button">
                <img src={CancelButton} alt="" onClick={() => { setHelpHub(false); isActive && isActive(false) }} />
              </div>
            </div>
          </div>

          <div className="q-helphub-updates-lower-cont">
            <div className="q-helphub-updates-lower-cont-data">
              <div className="q-helphub-updates-task-cont">
                {filterData.map(
                  (value: QuestCriteriaWithStatusType, index: number) =>
                    claimStatusUpdates.includes(value?.criteriaId) ? (
                      <div
                        className={`q-helphub-updates-single-update-read`}
                        key={index}
                        style={{
                          background: themeConfig?.backgroundColor,
                          ...styleConfig?.Home?.Card,
                        }}
                        onClick={() => {
                          handleShowUpdate(value);
                        }}
                      >
                        <div
                          className="update-img"
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              flexShrink: "0",
                              borderRadius: "2.237px",
                              objectFit: "contain",
                              backgroundColor: "transparent"
                            }}
                          >
                            <img src={value?.imageUrl || entityImage} alt="" style={{ width: '100%', height: '100%', maxWidth: "60px", maxHeight: "60px" }} />
                          </div>
                        </div>

                        <div className="read-task-details">
                          <div className="update-time">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_7694_4397)">
                                <circle
                                  cx="4.00033"
                                  cy="4.00002"
                                  r="3.33333"
                                  fill={
                                    "#636363"
                                  }
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_7694_4397">
                                  <rect width="8" height="8" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <p
                              style={{
                                color: "#636363",
                                fontFamily:
                                  BrandTheme?.fontFamily ||
                                  themeConfig?.fontFamily,
                                WebkitTextFillColor: "#636363",
                                ...styleConfig?.Updates?.Card?.SubHeading,
                              }}
                            >
                              {getTimeDifference(value?.createdAt)}
                            </p>
                          </div>
                          <div className="update-head">
                            <p
                              style={{
                                color:
                                  BrandTheme?.titleColor ||
                                  themeConfig?.primaryColor,
                                fontFamily:
                                  BrandTheme?.fontFamily ||
                                  themeConfig?.fontFamily,
                                ...styleConfig?.Updates?.Card?.Heading,
                              }}
                            >
                              {value?.linkTitle}
                            </p>
                            <img src={OpenSectionButton} alt="" />
                          </div>
                          <div
                            className="update-desc"
                            style={{
                              color:
                                BrandTheme?.contentColor ||
                                themeConfig?.secondaryColor,
                              fontFamily:
                                BrandTheme?.fontFamily ||
                                themeConfig?.fontFamily,
                              ...styleConfig?.Updates?.Card?.SubHeading,
                            }}
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className={`q-helphub-updates-single-update-read`}
                        key={index}
                        onClick={() => {
                          handleShowUpdate(value);

                          readUpdate(
                            value?.criteriaId
                            // value?.data?.metadata?.linkActionUrl
                          );
                        }}
                      >
                        <div
                          className="update-img"
                        >
                          <div
                            style={{
                              width: "60px",
                              height: "60px",
                              flexShrink: "0",
                              borderRadius: "2.237px",
                              objectFit: "contain",
                              backgroundColor: "transparent"
                            }}
                          >
                            <img src={value?.imageUrl || entityImage} alt="" style={{ width: '100%', height: '100%', maxWidth: "60px", maxHeight: "60px" }} />
                          </div>
                        </div>

                        <div className="read-task-details-unread">
                          <div className="update-time">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_7694_4382)">
                                <circle
                                  cx="4.00033"
                                  cy="4.00002"
                                  r="3.33333"
                                  fill="url(#paint0_linear_7694_4382)"
                                />
                              </g>
                              <defs>
                                <linearGradient
                                  id="paint0_linear_7694_4382"
                                  x1="0.693659"
                                  y1="7.33335"
                                  x2="7.96673"
                                  y2="6.58859"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop
                                    stop-color={
                                      color ||
                                      BrandTheme?.tertiaryColor ||
                                      "#9035FF"
                                    }
                                  />
                                  <stop
                                    offset="1"
                                    stop-color={
                                      color ||
                                      BrandTheme?.tertiaryColor ||
                                      "#0065FF"
                                    }
                                  />
                                </linearGradient>
                                <clipPath id="clip0_7694_4382">
                                  <rect width="8" height="8" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            <p
                              style={{
                                color:
                                  color ||
                                  BrandTheme?.tertiaryColor ||
                                  themeConfig?.secondaryColor,
                                fontFamily:
                                  BrandTheme?.fontFamily ||
                                  themeConfig?.fontFamily,
                                WebkitTextFillColor:
                                  color ||
                                  BrandTheme?.tertiaryColor ||
                                  "transparent",
                              }}
                            >
                              {getTimeDifference(value?.createdAt)}
                            </p>
                          </div>
                          <div className="update-head">
                            <p
                              style={{
                                color:
                                  BrandTheme?.titleColor ||
                                  themeConfig?.primaryColor,
                                fontFamily:
                                  BrandTheme?.fontFamily ||
                                  themeConfig?.fontFamily,
                              }}
                            >
                              {value?.linkTitle}
                            </p>
                            <img src={UnreadUpdateDarkArror} alt="" />
                          </div>
                          <div
                            className="update-desc"
                            style={{
                              color:
                                BrandTheme?.contentColor ||
                                themeConfig?.secondaryColor,
                              fontFamily:
                                BrandTheme?.fontFamily ||
                                themeConfig?.fontFamily,
                              // ...styleConfig?.Home?.Heading,
                            }}
                            dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.description) }}
                          />
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showOneUpdate && (
        <div
          className={`q-update-one-container ${!updateOneoutAnimation ? "updateOneIn" : "updateOneOut"
            }`}
        >
          <div
            className="q-update-one-container-header"
            style={{
              background: themeConfig?.backgroundColor,
              ...styleConfig?.Home?.Card,
            }}
          >
            <div
              className="image-div"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setUpdateOneOutAnimation((prev) => !prev);
                setUpdateOutTempAnimation(true);
                setTimeout(() => {
                  setShowBottomNavigation && setShowBottomNavigation(true);
                  setUpdateOutAnimation(false);
                  setshowOneUpdate((prev) => !prev);
                }, 250);
              }}
            >
              <HelphubSvg type={"BackButton"} />
            </div>

            <div
              className="q-update-one-container-header-title"
              style={{
                color: BrandTheme?.titleColor || themeConfig?.secondaryColor,
                ...styleConfig?.Home?.Heading,
                fontFamily: themeConfig?.fontFamily,
              }}
            >
              New Updates Details
            </div>
          </div>

          <div
            className="q-update-one-container-data"
            style={{
              background: themeConfig?.backgroundColor,
              // ...styleConfig?.Home?.Card,
            }}
          >
            <div
              className="update-one-img"
              style={{ background: extractGradientColors(BrandTheme?.primaryColor || QuestThemeData?.accentColor), borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius }}
            >
              <div
                style={{
                  background: `url(${updateOneData?.imageUrl || entityImage
                    }) transparent -10.312px -8.675px / 110.971% 102.745% no-repeat`,
                  objectFit: "contain",
                  borderColor: getColorVariations(
                    QuestThemeData?.accentColor,
                    -0.5
                  ).darker,
                }}
              ></div>
            </div>

            <div className="update-one-text-cont">
              <div className="update-text-head-time">
                {updateOneData?.completed ? (
                  <div className="update-one-time-read">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7694_4397)">
                        <circle
                          cx="4.00033"
                          cy="4.00002"
                          r="3.33333"
                          fill={
                            "#636363"
                          }
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7694_4397">
                          <rect width="8" height="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p
                      style={{
                        color: "#636363",
                        fontFamily:
                          BrandTheme?.fontFamily || themeConfig?.fontFamily,
                        textTransform: "uppercase"
                        // ...styleConfig?.Home?.Heading,
                      }}
                    >
                      {getTimeDifference(updateOneData?.createdAt)}
                    </p>
                  </div>
                ) : (
                  <div className="update-one-time">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="8"
                      viewBox="0 0 8 8"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7694_4382)">
                        <circle
                          cx="4.00033"
                          cy="4.00002"
                          r="3.33333"
                          fill="url(#paint0_linear_7694_4382)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_7694_4382"
                          x1="0.693659"
                          y1="7.33335"
                          x2="7.96673"
                          y2="6.58859"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop
                            stop-color={
                              color ||
                              "#9035FF"
                            }
                          />
                          <stop
                            offset="1"
                            stop-color={
                              color ||
                              "#0065FF"
                            }
                          />
                        </linearGradient>
                        <clipPath id="clip0_7694_4382">
                          <rect width="8" height="8" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p
                      style={{
                        color:
                          color ||
                          themeConfig?.secondaryColor,
                        fontFamily: themeConfig?.fontFamily,
                        WebkitTextFillColor:
                          color || "transparent",
                      }}
                    >
                      {getTimeDifference(updateOneData?.createdAt || "")}
                    </p>
                  </div>
                )}
                <div
                  className="update-one-head"
                  style={{
                    color:
                      BrandTheme?.titleColor || themeConfig?.primaryColor,
                    fontFamily:
                      BrandTheme?.fontFamily || themeConfig?.fontFamily,
                  }}
                >
                  {updateOneData?.linkTitle}
                </div>
              </div>

              <div
                className="update-one-update-desc"
                dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(updateOneData?.description) }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpHubUpdates;
